import { ObjectSchema, object, string, boolean } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { Graph, GraphType } from './../../models/graphs';
yup.setLocale(locale);

export function GraphValidator(): ObjectSchema<Graph> {
    return object({
        id: string().uuid().nonNullable().strict().notRequired(),
        type: string().oneOf([GraphType.Bar, GraphType.Gauge, GraphType.Exhaust]).nonNullable().required(),
        title: string()
            .test('not-whitespace', 'errors.validation.generic.trim', value => value.trim().length > 0)
            .nonNullable()
            .strict()
            .required()
            .max(48),
        vesselId: string().uuid().nonNullable().strict().required(),
    })
        .required()
        .strict()
        .noUnknown()
        .nonNullable() as ObjectSchema<Graph>;
}
